<template>
  <div id="ContractCPIHistoryTabView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div class="cpi-rate-history-tab table-responsive-sm"></div>
    <template v-if="dataArray && !is_edit">
      <template v-for="(record, index) in dataArray">
        <b class="font-bold">{{ record[0].section_name }}</b>
        <table aria-describedby="table" id="" class="table table-sm table-bordered font-1">
          <thead>
          <tr class="table-primary">
            <th>Contract Rate Effective</th>
            <th>Rate Change Reason</th>
            <th>Comment</th>
            <th style="text-align:right">Rate</th>
            <th >Action</th>
          </tr>
          </thead>
          <tbody>

          <template v-for="(data, index) in record">
            <tr v-bind:key="'recordRow'+index">
              <td>{{ data.created_at }}</td>
              <td>{{ data.reason }}</td>
              <td>{{ data.comment }}</td>
              <td style="text-align:right">{{ data.section_value }}</td>
              <td style="text-align:right">
                <button v-if="data.showEditButton" title="Edit Rate" class="btn btn-primary"
                        v-on:click="editRate(data.rate_history_id, data.section_id)">
                        <i class="fp-edit-icon"> </i> Edit
                </button>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </template>
    </template>
    <template v-else>
      <tr>
        <td colspan="5" class="text-center">No Record Found</td>
      </tr>
    </template>
    <!-- <template v-if="is_edit">
      <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title "
            id="ContractAssetDetailForm">
        <div class="alert-contract field-error hide"></div>
        <div class="row">
          <div class="col form-group">
            <label class="control-label require" for="section.id">Section:</label>
          </div>
          <div class="col form-group">
            <label class="control-label require" for="section_value">Rate:</label>
          </div>
          <div class="col form-group">
            <label class="control-label require" for="section_value">Effective Date:</label>
          </div>
          <div class="col form-group">
            <label class="control-label" for="section_value">CPI Rate:</label>
          </div>
        </div>
        <div class="row">
          <input type="hidden" class="form-control" v-model="id" placeholder="" name="rate_id">
          <div class="col-md-3 form-group">
            <v-select class="section-id" :disabled="close" v-model="section_id"
                      @change="onSectionChange($event,'change')" name="rate_section_id"
                      placeholder="Select Section Rate"
                      label="text"
                      :options="sectionTypes">
            </v-select>
            <div class="field-error">{{ section_error_msg }}</div>
          </div>
          <div class="col form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">$</div>
              </div>
              <input type="text" :disabled="close" ref="infoBox" class="form-control text-right"
                     v-model="section_value" id="section_value" placeholder="Section Value"
                     name="section_value" aria-describedby="basic-addon3" @keypress="isAmountCheck($event)">
            </div>
            <div class="field-error">{{ section_value_error_msg }}</div>
          </div>
          <div class="col form-group">
            <date-picker placeholder="MM/DD/YYYY" id="cpi_effective_date" :config="optionsDate"
                         name="cpi_effective_date"
                         v-model="cpi_effective_date" for></date-picker>
            <div class="field-error">{{ effective_date_error_msg }}</div>
          </div>
          <div class="col form-group">
            <v-select v-model="cpi_rate_id" name="contract_cpi_rate_id" placeholder="Select CPI Rate."
                      label="text"
                      :options="cpiRateArr">
            </v-select>
            <div class="field-error">{{ cpi_rate_error_msg }}</div>
          </div>
        </div>
        <template>
          <button type='button' title="Edit Asset" class="btn btn-primary"
                  v-on:click="updateRateHistory()">
            <i class="fp-save"> </i> Add
          </button>
        </template>
      </form>
    </template> -->
  </div>
</template>
<script>
import {commonMixins} from '../../mixins/commonMixins';

export default {
  name: "ContractCPIHistoryTabView",
  mixins: [commonMixins],
  props: {
    contractCpiRateHistoryVal: {
      type: String,
      required: false,
      default: undefined
    }
  },
  watch: {
    contractCpiRateHistoryVal: function (contractCpiRateHistoryVal) {
      var self = this;

      if (contractCpiRateHistoryVal === 'loadList') {
        var path = window.location.pathname;
        var segments = path.split("/");
        self.contractCPIRateChangeHistoryData(segments[3]);
      }
    }

  },
  data: () => ({
    checkCol: true,
    role: "",
    contractAssetArr: [],
    dataArray: [],
    contractCronArr: [],
    loading: false,
    sectionratesArr: [],
    rate_history_id: "",
    sectionTypes: [],
    cpiRateArr: [],
    is_edit: false,
    optionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
    },
    close: false,
    id: '',
    section_id: '',
    section_value: '',
    cpi_rate_id: '',
    cpi_effective_date: '',
    section_error_msg: "",
    section_value_error_msg: "",
    cpi_rate_error_msg: "",
    effective_date_error_msg: "",
    showEdit: true,
  }),
  created: function () {
  },
  mounted: function () {
    var self = this;
    var path = window.location.pathname;
    var segments = path.split("/");
    self.contractCPIRateChangeHistoryData(segments[3]);

  },
  methods: {
    contractCPIRateChangeHistoryData(id) {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/get-contract-section_rate_history",
        type: "GET",
        headers: this.ajxHeaders,
        crossDomain: true,
        dataType: 'json',
        data: {
          id: id,
        },
        success: function (data) {
          if (data.status === "success") {
            self.loading = false;
            var html = "";
            var sectionId = 0;
            if (data.content.cron.length > 0) {
              self.dataArray = self.groupBy(data.content.cron, 'section_name')
              $.each(self.dataArray,function (key,value){
                $.each(value,function(key2,value2){
                  if (value2.reason == "INITIAL RATE"){
                    value2.showEditButton = false;
                  }else{
                    value2.showEditButton = true;
                  }
                });
              });
              console.log('dataArraydataArray  ==', self.dataArray)
            } else {
              html = 'No Data Found!';
            }
            $(".cpi-rate-history-tab").html(html);
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.Registerbtn = "Register";
          if (jqXHR.status === 0) {
            self.registerError = "Remote server cannot be reached";
          }
        }
      });
    },

    titleCase(str) {
      if (str == null) {
        return;
      } else {
        var value = str.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    groupBy(array, key) {
      const result = {}

      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },
    editRate(rate_history_id, section_id) {
      const self = this;
      // self.is_edit = true
      this.$parent.rate_history_id = rate_history_id;
      this.$parent.history_section_id = section_id;
      // self.getSectionTypes();
      // self.getRateHistoryData(rate_history_id, section_id);
    },
    getSectionTypes() {
      const self = this;

      $.ajax({
        url: process.env.ROOT_API + "/contracttype/getsectionrate",
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            self.sectionTypes = data.content;
          }
        },
        error: function (jqXHR) {
        }
      });
    },
    getRateHistoryData(rate_history_id, section_id) {
      const self = this;
      const path = window.location.pathname;
      self.loading = true;
      self.addRate = false;

      $.ajax({
        url: process.env.ROOT_API + "/contract/getRateHistory",
        type: "POST",
        data: {"rate_history_id": rate_history_id, "section_id": section_id},
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            console.log('data===', data)

            self.id = (data.content[0].id) ? data.content[0].id : 0;
            self.section_id = (data.content[0].section_id != null && data.content[0].section_id != undefined) ? {
              value: data.content[0].section_id,
              text: data.content[0].name,
              code: data.content[0].code
            } : "";
            self.section_value = data.content[0].section_value;
            if (data.content[0].ecr_id) {

              self.cpi_rate_id = (data.content[0].cpi_percent != '') ? {
                text: "CPI:" + data.content[0].cpi_percent + " | Rate:" + data.content[0].rate_increase_percent + " | Limit:" + data.content.limit_percent,
                value: data.content[0].cpi_rate_id
              } : '';

            } else {
              self.cpi_rate_id = '';
            }
            self.cpi_effective_date = {value: data.content[0].effective_date, text: data.content[0].effective_date}
            setTimeout(function () {
              self.onSectionChange('', '', 'on_load');
            }, 500);
          }
        },
        error: function (jqXHR) {
          self.getSectionRates();
          self.loading = false;
        }
      });
    },
    onSectionChange: function (evt, flag) {
      var self = this;

      if (flag === 'change') {
        if (evt.code.toLowerCase() == 'fixed') {
          if (self.cpiRateArr.length > 0) {
            for (var i = 0; i < self.cpiRateArr.length; i++) {
              if (self.cpiRateArr.for === 'fixed' && self.cpiRateArr.default === 1 && (self.cpi_rate_id == null || self.cpi_rate_id === '')) {
                self.cpi_rate_id = {
                  text: self.cpiRateArr.text,
                  value: self.cpiRateArr.value
                };
              }
            }
          }
        } else {
          if (self.cpiRateArr.length === 0) {
            for (var i = 0; i < self.cpiRateArr.length; i++) {
              if (self.cpiRateArr.for === 'variable' && self.cpiRateArr.default === 1 && (self.cpi_rate_id == null || self.cpi_rate_id === '')) {
                self.cpi_rate_id = {
                  text: self.cpiRateArr.text,
                  value: self.cpiRateArr.value
                };

              }
            }
          }

        }
      }
    },
    updateRateHistory() {
      var self = this;
      var error = false;
      var sectionArr = [];
      var path = window.location.pathname;
      var segments = path.split("/");
      var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

      self.section_error_msg = "";
      self.section_value_error_msg = "";
      self.cpi_rate_error_msg = "";
      self.rate_increase_error_msg = "";
      self.effective_date_error_msg = "";

      if (self.section_id == null || !self.section_id.value) {
        self.section_error_msg = "Section Rate Required.";
        error = true;
      } else {
        sectionArr.push(self.section_id.value);
      }

      if (self.section_value == null || self.section_value == 0) {
        self.section_value_error_msg = "Section Value Required.";
        error = true;
      } else {
        if (self.section_value && self.section_value.includes(',')) {
          self.section_value = self.section_value.replace(',', '');
        }

        if (!self.section_value.match(checkNumber)) {
          self.section_value_error_msg = "Section Value is not valid.";
          error = true;
        }

        if (!self.cpi_effective_date || self.cpi_effective_date === "") {
          self.effective_date_error_msg = "Effective Date is required.";
          error = true;
        }
      }
      if (error == false) {
        var fields = {
          rate_history_id: self.rate_history_id,
          section_id: self.section_id.value,
          section_value: self.section_value,
          cpi_effective_date: self.cpi_effective_date,

        };
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/contract/updateRateHistory",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status === "success") {
              window.location.reload();
            } else {
              if (data.content.length > 0) {
                var err = "<ul>";
                $(".alert-contract").empty();

                for (var i = 0; i < data.content.length; i++) {
                  err += "<li>" + data.content[i] + "</li>";
                }
                err += "</ul>";
                $(".alert-contract").append(err);
                $(".alert-contract").addClass("show");
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, true, 'contract-asset-detail-create')
          }
        });
      }

    },
    convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/components/contract/TabContractCPIRateChangeHistory.vue